import React, { Fragment } from "react";

function LoadData() {
    return (
        <Fragment>
            <div className="text-center py-2 animate-pulse p-1 flex m-auto justify-center intro-y my-10">
                {/* border-4 border-gray-100  */}
                <div className="shadow-sm rounded-3xl p-1 w-3/6 bg-white">
                    <i className="animate-bounce fas fa-download fa-8x text-gray-300"></i>

                    <h1 className="text-base md:text-xl lg:text-3xl mt-1 text-gray-300">
                        กำลังโหลดข้อมูล..
            </h1>
                </div>
            </div>
        </Fragment>
    );
}

export default LoadData;
